const utf8Encoder = new TextEncoder()

export function fileToBase64(file: File): Promise<string> {
  return new Promise((done, fail) => {
    const reader = new FileReader
    reader.onload = () => {
      const dataURL = reader.result as string
      const [, base64 ] = dataURL.split(',')
      done(base64)
    }
    reader.onerror = fail
    reader.readAsDataURL(file)
  })
}

export async function fileToArrayBuffer(file: File) {
  return await file.arrayBuffer()
}

export async function fileToUTF16(file: File) {
  return await file.text()
}

export async function fileToUTF8(file: File) {
  const utf16 = await file.text()
  return utf8Encoder.encode(utf16)
}

